// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2iBcN","errorLogs":"EditorFooter_errorLogs__1iNI3"};